import { Model } from '@vuex-orm/core'
import Room from '@/models/Room'
import RatePlan from '@/models/RatePlan'
import RatePlanExtra from '@/models/RatePlanExtra'
import Theme from '@/models/Theme'
import CheckoutExtra from './CheckoutExtra'
import { LangedItem } from './common/commons'

export default class Extra extends Model {
  declare extraID: number
  declare description: any // todo
  declare name: any // todo
  declare currentTheme: any // todo
  declare pricingMethod: number
  declare pricingPerAgeGroup: any[] // todo
  declare pricingPerRoom: number
  declare minQuantityPerRoom: number
  declare maxQuantityPerRoom: number
  declare rooms: any[] // todo
  declare themeId: number
  declare theme: Theme
  declare propertyRooms: Room[]
  declare isPaidOnArrival: boolean
  declare isAvailableWithAllCurrentAndFutureRooms: boolean
  declare linkedRatePlans: RatePlan[] // via RatePlanExtra
  declare questionOnBooking?: LangedItem[]
  declare questionHelpText?: LangedItem[]

  static entity = 'extra'

  static primaryKey = 'extraID'

  /* data fetched in special function: fetchExtras() in state.interactor.js */
  static fields() {
    return {
      extraID: this.attr(null),
      description: this.attr({}),
      name: this.attr({}),
      currentTheme: this.attr({}),
      pricingMethod: this.number(0),
      pricingPerAgeGroup: this.attr([]),
      pricingPerRoom: this.number(1.0),
      minQuantityPerRoom: this.number(0),
      maxQuantityPerRoom: this.number(0),
      rooms: this.attr([]),
      themeId: this.number(0),
      theme: this.belongsTo(Theme, 'themeId'),
      propertyRooms: this.hasManyBy(Room, 'rooms'),
      isPaidOnArrival: this.attr(false),
      isAvailableWithAllCurrentAndFutureRooms: this.attr(false),
      linkedRatePlans: this.belongsToMany(RatePlan, RatePlanExtra, 'ratePlanId', 'id'),
      questionOnBooking: this.attr(null),
      questionHelpText: this.attr(null),
    }
  }

  get isPerUnitPricing() {
    return this.pricingMethod === 7
  }

  get currentThemes() {
    return this.currentTheme && this.currentTheme.extraThemeID || 0
  }

  get langedName() {
    return (this.name && this.name[0] && this.name[0].value) || ''
  }

  get langedDescription() {
    return (this.description && this.description[0] && this.description[0].value) || ''
  }

  get totalValue() {
    // Cast to a pivoted model
    const that = this as unknown as PivotedExtra
    if (!that.pivot) { return null }

    return that.isPerUnitPricing
      ? (that.pivot.quantity - that.pivot.includedQuantity) * that.pivot.totalPrice
      : that.pivot.totalPrice
  }

  static updateMinMaxQuantities(
    payload: {
      extraID: Extra['extraID'],
      minQuantityPerRoom?: Extra['minQuantityPerRoom'],
      maxQuantityPerRoom?: Extra['maxQuantityPerRoom']
    }[]
  ) {
    this.update(payload)
  }

  static beforeCreate(model: Extra) {
    model.themeId = model.currentTheme && model.currentTheme.id
  }
}

export interface PivotedExtra extends Extra {
  pivot: CheckoutExtra
}
